import {
	OWN_HOME_INCOME_FALLBACK,
	OWN_HOME_RENT_FALLBACK,
	OWN_HOME_SAVINGS_FALLBACK,
} from "web_myplann/Inspiration/OwnHome/constants";
import type { OwnHomeInputs } from "web_myplann/Inspiration/OwnHome/Types/OwnHomeTypes";
import { useResetStateOnOpen } from "web_myplann/Shared/Hooks/useResetStateOnOpen";

type Args = {
	open: boolean;
	initial: OwnHomeInputs;
};

type Result = {
	rent: number;
	setRent: (value: number) => void;
	income: number;
	setIncome: (value: number) => void;
	savings: number;
	setSavings: (value: number) => void;
};

export const useOwnHomeEstimate = ({ open, initial }: Args): Result => {
	const [rent, setRent] = useResetStateOnOpen(
		open,
		initial.rent ?? OWN_HOME_RENT_FALLBACK,
	);
	const [income, setIncome] = useResetStateOnOpen(
		open,
		initial.income ?? OWN_HOME_INCOME_FALLBACK,
	);
	const [savings, setSavings] = useResetStateOnOpen(
		open,
		initial.savings ?? OWN_HOME_SAVINGS_FALLBACK,
	);

	return { rent, setRent, income, setIncome, savings, setSavings };
};
